import React from 'react';
import { useResponsive } from '../hooks/useResponsive';

const AssignmentStatisticsCard = ({ statistics }) => {
  const { isDesktop } = useResponsive();

  const { total, pending, completed, overdue } = statistics;
  const completionPercentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  const styles = {
    container: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      padding: isDesktop ? '24px' : '16px',
      marginBottom: isDesktop ? '20px' : '12px',
    },
    title: {
      fontSize: isDesktop ? '20px' : '18px',
      fontWeight: 'bold',
      marginBottom: isDesktop ? '20px' : '16px',
      color: '#333',
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
      gap: isDesktop ? '20px' : '12px',
      marginBottom: isDesktop ? '20px' : '16px',
    },
    statBox: {
      textAlign: 'center',
      padding: isDesktop ? '20px' : '16px',
      borderRadius: '8px',
      border: '2px solid',
    },
    statNumber: {
      fontSize: isDesktop ? '32px' : '24px',
      fontWeight: 'bold',
      marginBottom: '8px',
      display: 'block',
    },
    statLabel: {
      fontSize: isDesktop ? '14px' : '12px',
      fontWeight: '500',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    progressContainer: {
      marginTop: isDesktop ? '20px' : '16px',
    },
    progressLabel: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
      fontSize: isDesktop ? '14px' : '13px',
      fontWeight: '500',
      color: '#666',
    },
    progressBar: {
      width: '100%',
      height: isDesktop ? '24px' : '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '12px',
      overflow: 'hidden',
      position: 'relative',
    },
    progressFill: {
      height: '100%',
      backgroundColor: '#388e3c',
      transition: 'width 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingRight: '8px',
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#fff',
    },
  };

  const statBoxStyles = {
    total: {
      ...styles.statBox,
      backgroundColor: '#f5f5f5',
      borderColor: '#e0e0e0',
    },
    pending: {
      ...styles.statBox,
      backgroundColor: '#fff3e0',
      borderColor: '#f57c00',
    },
    completed: {
      ...styles.statBox,
      backgroundColor: '#e8f5e9',
      borderColor: '#388e3c',
    },
    overdue: {
      ...styles.statBox,
      backgroundColor: '#ffebee',
      borderColor: '#d32f2f',
    },
  };

  const statColors = {
    total: '#333',
    pending: '#f57c00',
    completed: '#388e3c',
    overdue: '#d32f2f',
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Assignment Overview</h2>

      <div style={styles.statsGrid}>
        <div style={statBoxStyles.total}>
          <span style={{ ...styles.statNumber, color: statColors.total }}>{total}</span>
          <span style={{ ...styles.statLabel, color: statColors.total }}>Total</span>
        </div>

        <div style={statBoxStyles.pending}>
          <span style={{ ...styles.statNumber, color: statColors.pending }}>{pending}</span>
          <span style={{ ...styles.statLabel, color: statColors.pending }}>Pending</span>
        </div>

        <div style={statBoxStyles.completed}>
          <span style={{ ...styles.statNumber, color: statColors.completed }}>{completed}</span>
          <span style={{ ...styles.statLabel, color: statColors.completed }}>Completed</span>
        </div>

        <div style={statBoxStyles.overdue}>
          <span style={{ ...styles.statNumber, color: statColors.overdue }}>{overdue}</span>
          <span style={{ ...styles.statLabel, color: statColors.overdue }}>Overdue</span>
        </div>
      </div>

      <div style={styles.progressContainer}>
        <div style={styles.progressLabel}>
          <span>Completion Progress</span>
          <span>{completionPercentage}%</span>
        </div>
        <div style={styles.progressBar}>
          <div
            style={{
              ...styles.progressFill,
              width: `${completionPercentage}%`,
            }}
          >
            {completionPercentage >= 15 && `${completionPercentage}%`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentStatisticsCard;
